import type { RenderLink } from '@ui/web/utils'
import { Button } from '@ui/web/components'
import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

interface EmptyProps {
  className?: string
  type: 'web' | 'school'
  /** When provided with linkHref, the empty state shows a CTA button that navigates to this link. */
  renderLink?: RenderLink
}

export function Empty({ className, type, renderLink }: EmptyProps) {
  const showCta = !!renderLink

  return (
    <div
      className={cn(
        'srd:w-full srd:flex srd:flex-col srd:items-center srd:justify-center srd:gap-y-2 srd:h-fit srd:min-h-[80dvh] srd:max-w-[800px] srd:mx-auto',
        type === 'school' && 'srd:text-neutrals-black',
        type === 'web' && 'srd:text-neutrals-white',
        className,
      )}
    >
      <img src={getStaticAssetUrl('illustration/foam.png')} alt='' width={60} height={60} draggable={false} />

      <h6 className='srd:font-medium srd:text-xl'>
        {type === 'school' ? 'Bagikan bahan baca ke murid' : 'Bagikan bahan baca ke anak'}
      </h6>

      <p className='srd:text-center srd:text-sm'>
        Dorong minat baca dan perkuat pelajaran dengan menyuguhkan bahan baca yang sesuai kebutuhan.
      </p>

      {showCta && <Button asChild>{renderLink({ children: 'Mulai kirim koleksi bacaan susunanmu' })}</Button>}
    </div>
  )
}
